<script lang="ts">
    import { getTypedContext } from "@lib/svelte-typed-context";

    import { videoControllerToken } from "./context_tokens";
    import VideoPlayerUISlider from "./VideoPlayerUISlider.svelte";

    const videoController = getTypedContext(videoControllerToken);

    let duration = videoController.duration$;
    let time = videoController.time$;
    let buffered = videoController.buffered$;
    const handleChange = (time: CustomEvent<number>) => {
        videoController.seek(time.detail);
    };
</script>

<VideoPlayerUISlider
    on:change={handleChange}
    loaded={$buffered}
    value={$time}
    max={$duration}
    withProgress={true}
/>
